import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-textarea',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class Textarea extends mixins(AbstractField) {
  @Prop(String) readonly value: string;
  @Prop([String, Number]) readonly maxlength: string | number;

  get model(): string {
    return this.value;
  }
  set model(val: string) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get currentLength() {
    return this.model?.length || 0;
  }

  // updated () { }

  // destroyed () { }
}
